import React, { useMemo } from 'react';
import { TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
export const EntitySchemaRelationPicker = props => {
    const { value, schema, disabled, className, textFieldProps, onChange } = props;
    const relations = useMemo(() => (schema === null || schema === void 0 ? void 0 : schema.relations) || [], [schema]);
    const selected = useMemo(() => {
        return relations.find(relation => relation.propertyName === value);
    }, [value, relations]);
    return (React.createElement(Autocomplete, { disabled: disabled, options: relations, className: className, value: selected || null, getOptionLabel: option => option.displayName, onChange: (_, value) => onChange === null || onChange === void 0 ? void 0 : onChange(value || undefined), renderOption: option => (React.createElement("span", null,
            React.createElement(Typography, null, option.displayName),
            React.createElement(Typography, { variant: 'body2', color: 'textSecondary' },
                option.target,
                " (",
                option.type,
                ")"))), renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Relationship Property' }, textFieldProps))) }));
};
export default EntitySchemaRelationPicker;
//# sourceMappingURL=EntitySchemaRelationPicker.js.map